import { BaseModal } from '../spriteLab/BaseModal';

export interface ExportModalOptions {
    defaultFilename: string;
    onExport: (filename: string, format: 'png' | 'gif') => void;
    t: (key: any) => string;
}

export class ExportModal extends BaseModal {
    private options: ExportModalOptions;

    constructor(options: ExportModalOptions) {
        super();
        this.options = options;
        this.buildDOM();
    }

    protected buildDOM(): void {
        this.backdrop.style.background = 'rgba(0, 0, 0, 0.7)';
        this.backdrop.style.backdropFilter = 'blur(4px)';

        this.card.style.width = '100%';
        this.card.style.maxWidth = '260px';
        this.card.style.padding = '24px';

        const title = document.createElement('h2');
        title.className = 'sl-modal-title';
        title.innerText = this.options.t('modal_export_title') || 'Export Sprite';
        title.style.marginBottom = '20px';
        this.card.appendChild(title);

        // Filename input has been removed as per user request
        // Format Selection
        const formatLabel = document.createElement('label');
        formatLabel.innerText = this.options.t('label_format') || 'Format';
        formatLabel.style.display = 'block';
        formatLabel.style.marginBottom = '8px';
        formatLabel.style.fontSize = '0.9rem';
        formatLabel.style.color = 'rgba(255,255,255,0.8)';
        this.card.appendChild(formatLabel);

        const formatContainer = document.createElement('div');
        formatContainer.style.display = 'flex';
        formatContainer.style.gap = '16px';
        formatContainer.style.marginBottom = '24px';

        const formatPngLabel = document.createElement('label');
        formatPngLabel.style.display = 'flex';
        formatPngLabel.style.alignItems = 'center';
        formatPngLabel.style.gap = '8px';
        formatPngLabel.style.cursor = 'pointer';

        const formatPngRadio = document.createElement('input');
        formatPngRadio.type = 'radio';
        formatPngRadio.name = 'export_format';
        formatPngRadio.value = 'png';
        formatPngRadio.checked = true;

        const formatPngText = document.createElement('span');
        formatPngText.innerText = 'PNG';

        formatPngLabel.appendChild(formatPngRadio);
        formatPngLabel.appendChild(formatPngText);

        const formatGifLabel = document.createElement('label');
        formatGifLabel.style.display = 'flex';
        formatGifLabel.style.alignItems = 'center';
        formatGifLabel.style.gap = '8px';
        formatGifLabel.style.cursor = 'pointer';

        const formatGifRadio = document.createElement('input');
        formatGifRadio.type = 'radio';
        formatGifRadio.name = 'export_format';
        formatGifRadio.value = 'gif';

        const formatGifText = document.createElement('span');
        formatGifText.innerText = 'GIF';

        formatGifLabel.appendChild(formatGifRadio);
        formatGifLabel.appendChild(formatGifText);

        formatContainer.appendChild(formatPngLabel);
        formatContainer.appendChild(formatGifLabel);
        this.card.appendChild(formatContainer);

        // Buttons
        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'sl-layout-64';

        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'sl-layout-65 sl-btn-animate';
        cancelBtn.innerText = this.options.t('action_cancel') || 'Cancel';
        cancelBtn.onclick = () => this.destroy();

        const exportBtn = document.createElement('button');
        exportBtn.className = 'sl-layout-66 sl-btn-animate';
        exportBtn.innerText = this.options.t('action_export_confirm') || 'Export';
        exportBtn.onclick = () => {
            const format = formatPngRadio.checked ? 'png' : 'gif';
            const filename = this.options.defaultFilename;
            this.options.onExport(filename, format);
            this.destroy();
        };

        buttonContainer.appendChild(cancelBtn);
        buttonContainer.appendChild(exportBtn);
        this.card.appendChild(buttonContainer);
    }
}